import http from "@/api/http";
import { subdomain } from "@/utilities";
export default {
  website() {
    let _url = "/theme/website";

    let _website = http({
      url: _url,
      method: "get",
      headers: {
        "X-Subdomain": subdomain.get(),
      },
    });
    return _website;
  },
};
